const BulletIcon = ({ text }: { text: string }) => {
  return (
    <div className="cx-bg-background-success cx-rounded-full cx-text-text-inverse cx-text-center">
      {text}
    </div>
  );
};

export default BulletIcon;
